import { Checkbox, Switch } from "antd";
import classNames from "classnames";
import React, { useState } from "react";
import styles from "../styles.module.scss";

type NotifyType = "Type 1" | "Type 2" | "Type 3" | "Type 4" | "Type 5";

const NOTIFY_TYPES: NotifyType[] = ["Type 1", "Type 2", "Type 3", "Type 5"];

interface NotificationPreferencesProps {
  subscriptionActive: boolean;
  onButtonClick: () => void;
}

export const NotificationPreferences: React.FC<
  NotificationPreferencesProps
> = ({ subscriptionActive, onButtonClick }) => {
  const [pushEnabled, setPushEnabled] = useState(true);
  const [emailEnabled, setEmailEnabled] = useState(true);

  const [pushSelected, setPushSelected] = useState<NotifyType[]>([
    "Type 2",
    "Type 5",
  ]);
  const [emailSelected, setEmailSelected] = useState<NotifyType[]>([
    "Type 2",
    "Type 5",
  ]);

  const toggleType = (
    list: NotifyType[],
    setter: React.Dispatch<React.SetStateAction<NotifyType[]>>,
    type: NotifyType,
  ) => {
    setter(
      list.includes(type) ? list.filter((t) => t !== type) : [...list, type],
    );
  };

  return (
    <section className={styles.notification}>
      <div className={styles.section}>
        <div className={styles.switch}>
          <Switch checked={pushEnabled} onChange={setPushEnabled} />
          <span className={styles.switchLabel}> Push notifications</span>
        </div>
        {pushEnabled && (
          <div className={styles.types}>
            {NOTIFY_TYPES.map((t) => (
              <div key={t}>
                <Checkbox
                  disabled={!pushEnabled}
                  checked={pushSelected.includes(t)}
                  onChange={() => toggleType(pushSelected, setPushSelected, t)}
                >
                  {t}
                </Checkbox>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={styles.section}>
        <div className={styles.switch}>
          <Switch checked={emailEnabled} onChange={setEmailEnabled} />
          <span className={styles.switchLabel}> Email notifications</span>
        </div>
        {emailEnabled && (
          <div className={styles.types}>
            {NOTIFY_TYPES.map((t) => (
              <div key={t}>
                <Checkbox
                  disabled={!emailEnabled}
                  checked={emailSelected.includes(t)}
                  onChange={() =>
                    toggleType(emailSelected, setEmailSelected, t)
                  }
                >
                  {t}
                </Checkbox>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={styles.subscription}>
        <div className={styles.info}>
          <div className={styles.status}>
            {subscriptionActive ? "Active" : "Inactive"}
          </div>
          <p className={styles.company}>
            <span className={styles.blue}>Nyle.AI</span> subscription
          </p>
        </div>
        <button
          className={classNames(styles.button, {
            [styles.active]: !subscriptionActive,
          })}
          onClick={onButtonClick}
        >
          {subscriptionActive ? "Unsubscribe" : "Subscribe"}
        </button>
      </div>
    </section>
  );
};
